import cookie from 'browser-cookies';

export const isQuickDepositDisabled = (disableQuickDeposit, enableQuickDepositCookie) =>
  !disableQuickDeposit && enableQuickDepositCookie
    ? cookie.get(enableQuickDepositCookie) === null
    : disableQuickDeposit;
